module.exports = __webpack_public_path__ + "static/img/gsjj3.d230cd1.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/gsjj3.png
// module id = 5UrM
// module chunks = 0